import { Avatar, CircularProgress, Dialog } from "@mui/material";
import ToolTipComponent from "../UniversalComponents/ToolTipComponent";
import LinkColorOnActive from "../../assets/images/icons/LinkColorOnActive";
import { useEffect, useRef, useState } from "react";
import Button from "../UniversalComponents/DefaultButton";
import NotesContentPreivew from "../GlobalFeature/Table/ExtraComponent/NotesContentPreivew";
import NotesPreviewDialog from "./NotesPreviewDialog";
import { getHexWithOpacity, getTitleCase } from "../../utils/utilityFunctions/stringUtility";
import { getUserDateTime } from "../../utils/utilityFunctions/UTCFormat";

const highlightTextInHtml = (html, highlight) => {
  if (!highlight?.trim()) return html;

  const regex = new RegExp(`(${highlight})`, "gi");
  const tempDiv = document.createElement("div");
  tempDiv.innerHTML = html;

  const walker = document.createTreeWalker(tempDiv, NodeFilter.SHOW_TEXT, null, false);
  let node;
  while ((node = walker.nextNode())) {
    const text = node.textContent;
    if (regex.test(text)) {
      const span = document.createElement("span");
      span.innerHTML = text.replace(regex, (match) => `<span class="bg-yellow-300">${match}</span>`);
      node.replaceWith(span);
    }
  }

  return tempDiv.innerHTML;
};

const PararagraphComponent = ({ CategoryData, searchTerm }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [showReadMore, setShowReadMore] = useState(false);
  const paragraphRef = useRef(null);

  useEffect(() => {
    const checkHeight = () => {
      if (paragraphRef.current) {
        const lineHeight = parseInt(window.getComputedStyle(paragraphRef.current).lineHeight);
        const height = paragraphRef.current.scrollHeight;

        const maxHeight = lineHeight * 3;

        setShowReadMore(height > maxHeight);
      }
    };

    checkHeight();

    const resizeObserver = new ResizeObserver(checkHeight);
    if (paragraphRef.current) {
      resizeObserver.observe(paragraphRef.current);
    }

    return () => {
      if (paragraphRef.current) {
        resizeObserver.unobserve(paragraphRef.current);
      }
      resizeObserver.disconnect();
    };
  }, [CategoryData]);

  const handleReadMoreClick = (e) => {
    e.stopPropagation();
    setIsExpanded(!isExpanded);
  };

  return (
    <div className="py-1 w-full overflow-auto">
      <p
        ref={paragraphRef}
        className={`text-xs font-400 w-full max-w-[20vw] text-justify text-[#383838] break-words ${isExpanded ? "" : "line-clamp-3 "}`}
        dangerouslySetInnerHTML={{
          __html: highlightTextInHtml(CategoryData, searchTerm),
        }}
      ></p>

      {showReadMore && (
        <button
          className="text-blue-500 hover:text-blue-600 font-300 text-xs cursor-pointer"
          onClick={(e) => handleReadMoreClick(e)}
        >
          {isExpanded ? "Read less" : "Read more"}
          {/* View Full Note */}
        </button>
      )}
    </div>
  );
};

const ExpandableNoteBody = ({
  info,
  key,
  createAvatarInitials,
  isAddButtonActive,
  handleLink,
  handleUnlink,
  highlightText,
  searchText,
}) => {
  const [isLoading, setIsLoading] = useState(false);

  const [isNotesPreviewOpen, setIsNotesPreviewOpen] = useState(false);

  const handleLinkUnlinked = async (data) => {
    try {
      setIsLoading(() => true);
      if (isAddButtonActive) {
        await handleLink(data?.id);
      } else {
        await handleUnlink(data?.note_id);
      }
    } catch (error) {
      console.log(error?.message);
    } finally {
      setIsLoading(() => false);
    }
  };

  return (
    // <div key={key} className="flex gap-1 hover:bg-[#EBF2F6]">
    <div
      key={key}
      className="flex flex-col gap-1 hover:bg-primary-hover w-full cursor-pointer border-b-[#D2DAE1] border min-h-10"
      onClick={() => setIsNotesPreviewOpen(true)}
    >
      <div className="flex flex-row w-full min-h-0 p-2">
        <div
          className={` rounded-lg cursor-pointer`}
          // style={
          //   idx % 2 === 0
          //     ? { borderLeft: `4px solid ${getHexWithOpacity(note?.colour_code, 40)}` }
          //     : { borderRight: `4px solid ${getHexWithOpacity(note?.colour_code, 40)}` }
          // }
        >
          <div className=" flex items-start justify-between p-1">
            {/* <div className="mr-3 mt-1">
                                <AvatarName
                                  name={getInitials(note.updated_by)}
                                  size="medium"
                                  bgColor={"#e8ecf299"}
                                  textColor={"#7C7C83"}
                                  borderColor={"#7C7C83"}
                                />
                              </div> */}

            <div className="flex items-start flex-col grow min-w-0">
              <div className="flex justify-between w-full">
                <div className="flex items-start gap-x-1 w-full">
                  <div className="min-w-0 grow truncate">
                    <p
                      className=" max-w-72 truncate text-[#383838] text-sm font-500 capitalize pb-[1px] "
                      style={{ color: info?.colour_code }}
                      dangerouslySetInnerHTML={{
                        __html: highlightTextInHtml(info?.notes_title, searchText),
                      }}
                    ></p>

                    <div className="flex items-center justify-start gap-x-2">
                      <div className="text-[#767676] text-xs font-normal  capitalize pr-1">{info?.created_by}</div>
                      <span className="h-3 w-[1px] bg-[#767676]"></span>

                      <div className="text-[#767676] text-xs font-normal  capitalize pr-1">
                        {getUserDateTime(info?.created_at, "DD-MM-YYYY")}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="flex items-start w-full noteViewPad">
                <PararagraphComponent CategoryData={info?.notes_body} searchTerm={searchText} />
              </div>

              <div className="flex flex-wrap items-center gap-x-2 gap-y-2 mt-1">
                {info?.tags?.map((option) => {
                  return (
                    <span
                      key={option?.value}
                      className="text-white text-xs font-medium px-2 py-1 rounded items-center"
                      style={{
                        backgroundColor: getHexWithOpacity(option?.color_code, 10) || "#666",
                        color: option?.color_code,
                        border: `1px solid ${option?.color_code}`,
                      }}
                    >
                      {option?.label}
                      {/* <button type="button" className="ml-2 text-white">
                                              <i className="bi bi-x"></i>
                                            </button> */}
                    </span>
                  );
                })}
              </div>
            </div>

            <div className="border-b-2"></div>
          </div>
        </div>
      </div>

      {console.log("infoVinay", isNotesPreviewOpen)}

      {isNotesPreviewOpen && (
        <NotesPreviewDialog
          open={isNotesPreviewOpen}
          onClose={(e) => {
            e.stopPropagation();
            setIsNotesPreviewOpen((prev) => !prev);
          }}
          fullWidth
          maxWidth={"md"}
          info={info}
        ></NotesPreviewDialog>
      )}
    </div>
  );
};

export default ExpandableNoteBody;
